import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { buildMockTestPath } from '../../utils/mockTestLinks';

export default function LegacyMockTestRoute({ exam, scope }) {
  const { state } = useLocation();
  const id = exam === 'pte' ? state?.Exam?.MockTestId : scope === 'full' ? state?.groupId : state?.testData?.id;
  const path = buildMockTestPath({ exam, scope, id });
  return <Navigate replace to={path || (exam === 'pte' ? '/MockTest' : '/ielts-dashboard')} state={{ ...state, launched: false }} />;
}
